import React from 'react';
import { i18n } from '@lt/localization';

import type { IFilter } from '../types';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';

const DESIGNATED_LABEL = i18n.t('filters.beach.type.privite');

const FilterBeachType = ({
  data,
  onChange,
  onClear,
  isMobile = false,
  className = '',
  currencyCode,
}: IFilter): JSX.Element => {
  const privateBeachCbx = data.find((item) => item.id === 'DESIGNATED');

  const checkboxes = [
    {
      ...privateBeachCbx,
      name: DESIGNATED_LABEL,
    },
  ];

  return (
    <MultichoiceFilterGroup
      className={className}
      data={checkboxes}
      onChange={onChange}
      onClear={onClear}
      Filter={FilterBeachType}
      isMobile={isMobile}
      currencyCode={currencyCode}
    />
  );
};

export default Object.assign(FilterBeachType, {
  filterName: 'beach_type',
  filterLabel: i18n.t('filters.beach.type.title'),
  FILTER_NAMES: {
    DESIGNATED: DESIGNATED_LABEL,
  },
  valuesLabel: (data) =>
    data.find((item) => item.id === 'DESIGNATED' && item.selected) &&
    DESIGNATED_LABEL,
});
